import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from "@headlessui/react";
import ExclamationIcon from '../icons/exclamation';
import CustomSeparator from "./separator"
import { classNames } from "../App";



export default function CustomModal({ open, setOpen, title, confirmButton, cancelButton, onConfirm, onCancel, children, noOutsideClick = false, withIcon = true, Icon = ExclamationIcon, confirmMode = false, onConfirmModeButton, lookupModalAdd = false, highWidthTable = false, fullWidth = false }) {



    return (
        <Dialog open={open} onClose={noOutsideClick ? () => { } : setOpen} className="relative z-50">
            <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed inset-0 z-50 w-screen overflow-y-auto mb-[8rem] sm:mb-0 mt-5 lg:mt-0">
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <DialogPanel
                        transition
                        className={classNames("relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95", lookupModalAdd ? 'sm:max-w-[260px]' : highWidthTable ? 'sm:max-w-[45rem]' : 'sm:max-w-[32rem]')}
                    >
                        <div className="sm:flex sm:items-start">
                            {withIcon && <div className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full sm:mx-0 sm:size-10">
                                <Icon className="size-6 mb-3" />
                            </div>}
                            <div className={classNames("mt-3 text-center sm:ml-2 sm:mt-0 sm:text-left", (highWidthTable || fullWidth) && "w-full")}>
                                <DialogTitle as="h3" className="text-base font-semibold text-gray-900">
                                    {title}
                                </DialogTitle>
                                <CustomSeparator className={"mt-4 mb-8"} />
                                <div className="mt-2 text-sm text-gray-500">
                                    {children}
                                </div>
                            </div>
                        </div>
                        {!confirmMode && <div className={classNames("mt-5 sm:mt-4 sm:flex sm:flex-row-reverse", lookupModalAdd && 'sm:justify-between')}>
                            <button
                                type="button"
                                onClick={() => onConfirm()}
                                className="inline-flex w-full justify-center rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary-dark sm:ml-3 sm:w-auto"
                            >
                                {confirmButton}
                            </button>
                            <button
                                type="button"
                                data-autofocus
                                onClick={() => onCancel()}
                                className="mt-3 inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-red-800 sm:mt-0 sm:w-auto"
                            >
                                {cancelButton}
                            </button>
                        </div>}
                        {confirmMode && <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                            <button
                                type="button"
                                onClick={() => onConfirmModeButton()}
                                className="inline-flex w-full justify-center rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary-dark sm:ml-3 sm:w-auto"
                            >
                                {cancelButton}
                            </button>
                        </div>}
                    </DialogPanel>
                </div>
            </div>
        </Dialog>
    )
}